import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CustomEmailValidator {

  static validate(control: AbstractControl) {
    const value = control.value;

    if (value) {
      const values = value.split('@');
      if (values.length >= 2) {
        if (values[0].length < 2) {
          return { pattern: true };
        }
        const domain = values[1].split('.');
        if (domain[0].length < 2) {
          return { pattern: true };
        }
      }
    }
    return null;
  }

}
